export default "__VITE_ASSET__5cb829ef__"